/**
 * Accordion ARIA Handler
 * Manages aria-describedby attribute dynamically for accordion accessibility
 * Only adds aria-describedby when accordion is open, removes when closed
 */

class AccordionAriaHandler {
  constructor(detailsElement) {
    this.details = detailsElement;
    this.summary = detailsElement.querySelector('summary');
    this.contentDiv = detailsElement.querySelector('.details-content > div[id]');
    
    if (this.summary && this.contentDiv) {
      this.init();
    }
  }

  init() {
    // Set initial state based on current open/closed state
    this.updateAria();
    
    // Listen for toggle events (when accordion opens/closes)
    this.details.addEventListener('toggle', () => {
      this.updateAria();
    });
  }

  updateAria() {
    if (this.details.open) {
      // When accordion is open, add aria-describedby to reference the content
      this.summary.setAttribute('aria-describedby', this.contentDiv.id);
    } else {
      // When accordion is closed, remove aria-describedby
      this.summary.removeAttribute('aria-describedby');
    }
  }
}

// Initialize for all accordions on page load
document.addEventListener('DOMContentLoaded', () => {
  const allDetails = document.querySelectorAll('accordion-custom details');
  allDetails.forEach(details => {
    new AccordionAriaHandler(details);
  });
});

// Also handle dynamically added accordions (e.g., loaded via AJAX)
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if the added node is an accordion-custom element
          if (node.matches && node.matches('accordion-custom')) {
            const details = node.querySelector('details');
            if (details) {
              new AccordionAriaHandler(details);
            }
          }
          // Check if accordion-custom elements were added inside the node
          const nestedDetails = node.querySelectorAll && node.querySelectorAll('accordion-custom details');
          if (nestedDetails) {
            nestedDetails.forEach(details => {
              new AccordionAriaHandler(details);
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
